// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xHeaderHandlerType } from "@eisinc/App/Handlers/XNG/Header";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft, original } from "immer";

export type xHeaderStateType = Readonly<{
    isSticky?: boolean;
    mobileSearch?: boolean;
    globalMessage?: boolean;
    stickyMenu: boolean;
    registerMenu?: string[];
    unregisterMenu?: string;
    headerHeight?: string;
    stickyHeader?: string;
    showSearchSectionOnMobile?: boolean;
    secondaryNavigationHeaderHeight?: string;
    stickyHeaderHeight?: string;
}>;

export const initialHeaderState: xHeaderStateType = {
    isSticky: false,
    mobileSearch: false,
    globalMessage: true,
    stickyMenu: false,
    registerMenu: [],
    unregisterMenu: "",
    headerHeight: "",
    stickyHeader: "",
    showSearchSectionOnMobile: false,
};

const reducer = {
    "xHeader/isSticky": (draft: Draft<xHeaderStateType>, action: { isSticky: boolean }) => {
        draft.isSticky = action.isSticky;
    },
    "xHeader/mobileSearch": (draft: Draft<xHeaderStateType>, action: { mobileSearch: boolean }) => {
        draft.mobileSearch = action.mobileSearch;
    },
    "xHeader/globalMessage": (draft: Draft<xHeaderStateType>, action: { globalMessage: boolean }) => {
        draft.globalMessage = action.globalMessage;
    },
    "xHeader/stickyMenu": (draft: Draft<xHeaderStateType>, action: { stickyMenu: boolean }) => {
        draft.stickyMenu = action.stickyMenu;
    },
    "xHeader/update": (draft: Draft<xHeaderStateType>, action: { data: xHeaderHandlerType }) => {
        if (action.data.key) {
            if (action.data.key === "registerMenu") {
                draft["registerMenu"]?.push(action.data.value);
            } else if (action.data.key === "unregisterMenu") {
                const currentStore = original(draft) as xHeaderStateType;
                draft["registerMenu"] = currentStore.registerMenu?.filter((item: string) => action.data.value !== item);
            } else {
                draft[action.data.key] = action.data.value as any;
            }
        }
    },
};

const xHeader = createTypedReducerWithImmer(initialHeaderState, reducer);

(reducers as any).xHeader = xHeader;

export type xHeaderState = {
    xHeader: xHeaderStateType;
};

type xHeaderReducers = {
    isSticky: typeof xHeader;
    mobileSearch: typeof xHeader;
    globalMessage: typeof xHeader;
    stickyMenu: typeof xHeader;
};

export type xHeaderActions = Parameters<xHeaderReducers[keyof xHeaderReducers]>[1] | AnyAction;
